import { render } from "./Role.vue?vue&type=template&id=3fc95bc5&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"

import "./Role.vue?vue&type=style&index=0&id=3fc95bc5&lang=scss&scoped=true"
import "./Role.vue?vue&type=style&index=1&id=3fc95bc5&lang=scss"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fc95bc5"]])

export default __exports__